<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { mapGetters, mapActions, mapState } from "vuex";
import paginationMixin from "@/mixins/paginationMixin";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Balance Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [paginationMixin],
  data() {
    return {
      current_date: moment(new Date()).format("YYYY-MM-DD"),
      title: "Customer Balance Details",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Customer Balance Details",
          active: true,
        },
      ],

      json_fields: {
        NAME: "customer.name",
        CONTACT: "customer.contact",
        DATE: "date",
        AMOUNT_IN: "amountIn",
        AMOUNT_OUT: "amountOut",
        DESCRIPTION: "Description",
        BALANCE: "newbalance",
        CATEGORY: "Category",
        RECORDED_BY: "user",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      total_amount: 0,
      total_paid: 0,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      totals: {
        totalin: 0,
        totalout: 0,
      },
      fields: [
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT RECEIVED",
        },
        {
          key: "amountIn",
          sortable: true,
          label: "AMOUNT IN",
        },
        {
          key: "amountOut",
          sortable: true,
          label: "AMOUNT OUT",
        },
        {
          key: "Description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "newbalance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "mode",
          sortable: true,
          label: "RECEIVED VIA",
        },
        {
          key: "Category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "actions",
          sortable: true,
          label: "Actions",
        },
      ],
      paginationConfig: {
        storeModule: "customers",
        dataGetter: "CustomerBalanceDetailsPaginated",
        paginationGetter: "CustomerBalanceDetailsPagination",
        serverPaginatedGetter: "IsCustomerBalanceDetailsServerPaginated",
        filterStatusGetter: "CustomerBalanceDetailsFilterStatus",
        fetchAction: "customers/fetchCustomerBalanceDetailsData",
        defaultFilters: {
          id: atob(this.$route.params.id),
          datefrom: null,
          dateto: moment(new Date()).format("YYYY-MM-DD"),
        },
        defaultPerPage: 50,
        disableSameDayPagination: false,
      },
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("customers", [
      "CustomerBalanceDetails",
      "CustomerBalanceDetailsSummary",
    ]),
    ...mapGetters("setting", ["ReceiptSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.CustomerBalanceDetails
        ? this.CustomerBalanceDetails.length
        : 1;
    },

    customerName() {
      return this.paginatedData && this.paginatedData[0]
        ? this.paginatedData[0].customer.name
        : "";
    },

    customerContact() {
      return this.paginatedData && this.paginatedData[0]
        ? this.paginatedData[0].customer.contact
        : "";
    },
    total_debit() {
      return this.CustomerBalanceDetailsSummary
        ? this.CustomerBalanceDetailsSummary.total_debit
        : 0;
    },

    total_credit() {
      return this.CustomerBalanceDetailsSummary
        ? this.CustomerBalanceDetailsSummary.total_credit
        : 0;
    },

    total_balance() {
      return this.CustomerBalanceDetailsSummary
        ? this.CustomerBalanceDetailsSummary.total_balance
        : 0;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.CustomerBalanceDetails
      ? this.CustomerBalanceDetails.length
      : 1;
  },
  methods: {
    ...mapActions({
      FetchBalanceDetails: "customers/fetchCustomerBalanceDetails",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
    }),
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    Receipt_print(newValue) {
      window.open(
        `https://${window.location.host}/receipts/depositreceipt.php?id=${btoa(
          newValue,
        )}`,
      );
    },
    Viewdetails(tid, category) {
      if (category == "Sale") {
        this.$router.push(`/sale_details/${btoa(tid)}`);
      } else if (category == "Deposit") {
        this.$router.push(`/customerdeposit_details/${btoa(tid)}`);
      } else if (category == "Refund") {
        this.$router.push(`/refund_details/${btoa(tid)}`);
      } else if (category == "Imported Debtor") {
        this.$router.push(`/debtor_details/${btoa(tid)}`);
      }
    },
    FilterRecords() {
      this.applyPaginationFilters();
    },

    printDescriptiveLedger() {
      this.$router.push(
        `/customer/descriptive_balancedetails/${btoa(
          this.paginationFilters.id,
        )}`,
      );
    },

    printLedger() {
      this.$router.push(
        `/customer/print_balance_details/${btoa(
          this.paginationFilters.id,
        )}/${btoa(this.paginationFilters.datefrom)}/${btoa(
          this.paginationFilters.dateto,
        )}`,
      );
    },
  },
  updated() {
    let total_in = 0;
    let total_out = 0;
    if (this.CustomerBalanceDetails) {
      this.CustomerBalanceDetails.forEach((item) => {
        total_in = total_in + parseInt(item.amountIn);
      });
      this.totals.totalin = total_in;
      this.CustomerBalanceDetails.forEach((item) => {
        total_out = total_out + parseInt(item.amountOut);
      });
      this.totals.totalout = total_out;
    }
  },
  created() {
    this.fetchReceiptSettings();
    this.FilterRecords();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <div
      class="row py-3 text-center"
      v-if="
        paginatedData &&
        paginatedData.length > 0 &&
        paginationFilters.datefrom == null
      "
    >
      <h4 class="text-primary text-uppercase">
        CUSTOMER PAYMENT REPORT FOR {{ customerName }} - {{ customerContact }}
        <br />
      </h4>
    </div>
    <div
      class="row py-3 text-center"
      v-if="
        paginatedData &&
        paginatedData.length > 0 &&
        paginationFilters.datefrom != null
      "
    >
      <h4 class="text-primary text-uppercase">
        CUSTOMER PAYMENT REPORT FOR {{ customerName }} - {{ customerContact }}
        <br />
        FROM {{ paginationFilters.datefrom }} TO {{ paginationFilters.dateto }}
      </h4>
    </div>
    <PageHeader :title="title" :items="items" />
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-4"></div>
            <div class="col-3 form-group mb-2">
              <label>FROM</label>
              <input
                type="date"
                v-model="paginationFilters.datefrom"
                class="form-control"
                v-limit-future-date
              />
            </div>
            <div class="col-md-3 form-group">
              <label>TO</label>
              <input
                v-model="paginationFilters.dateto"
                type="date"
                class="form-control"
                v-limit-future-date
              />
            </div>
            <div class="col-md-2 mt-4">
              <button
                class="btn btn-warning"
                type="button"
                @click="FilterRecords()"
                :disabled="isLoadingPagination"
              >
                <span class="fa fa-filter"></span> Filter
                <b-spinner
                  v-if="isLoadingPagination"
                  variant="light"
                  small
                  role="status"
                ></b-spinner>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <download-excel
                class="btn btn-info"
                :data="paginatedData"
                :fields="json_fields"
                :worksheet="'CUSTOMER BALANCE DETAILS AS OF ' + current_date"
                type="csv"
                :name="'Customerbalance_details ' + current_date + '.xls'"
              >
                Export <i class="fa fa-download"></i>
              </download-excel>
            </div>
            <div class="col-md-3" align="center">
              <b-button @click="printDescriptiveLedger()" variant="info"
                >Descriptive Ledger</b-button
              >
            </div>
            <div class="col-md-3" align="center">
              <b-button @click="printLedger()" variant="warning"
                ><i class="fa fa-print"></i> Print</b-button
              >
            </div>
            <div class="col-md-3" align="right">
              <b-button @click="$router.go(-1)" variant="warning"
                ><i class="fa fa-arrow-left"></i> Back</b-button
              >
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="paginationPerPage"
                    size="sm"
                    :options="pageOptions"
                    :disabled="isLoadingPagination"
                  ></b-form-select
                  >&nbsp;entries
                </label>
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive mb-0 mt-3">
            <table
              class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
            >
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>DATE</th>
                  <th>CATEGORY</th>
                  <th>RECEIVED VIA</th>
                  <th>DEBIT</th>
                  <th>CREDIT</th>
                  <th>BALANCE</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody
                v-if="
                  !isLoadingPagination &&
                  paginatedData &&
                  paginatedData.length > 0
                "
              >
                <tr v-for="(item, index) in paginatedData" :key="item.id">
                  <td>{{ calculatePaginationIndex(index) + 1 }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.Category }}</td>
                  <td>{{ item.mode }}</td>
                  <td>
                    {{ item.amountOut ? item.amountOut.toLocaleString() : 0 }}
                  </td>
                  <td>{{ item.amount ? item.amount.toLocaleString() : 0 }}</td>
                  <td>
                    {{ item.newbalance ? item.newbalance.toLocaleString() : 0 }}
                  </td>
                  <td>
                    <b-button-group>
                      <b-button
                        v-if="
                          ReceiptSettings.print_deposits == 1 && item.recno > 0
                        "
                        variant="info"
                        size="sm"
                        @click="Receipt_print(item.recno)"
                      >
                        Reprint
                      </b-button>
                      <b-button
                        variant="success"
                        size="sm"
                        @click="Viewdetails(item.transaction, item.Category)"
                      >
                        Details
                      </b-button>
                    </b-button-group>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="isLoadingPagination">
                <tr>
                  <td colspan="8" class="text-center">
                    <div class="text-warning my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody
                v-if="
                  !isLoadingPagination &&
                  (!paginatedData || paginatedData.length === 0)
                "
              >
                <tr>
                  <td colspan="8" class="text-center">
                    No balance details found for this customer.
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Summary -->
            <div class="row mt-3">
              <div class="col-md-4">
                <h5>
                  Total Debit:
                  <span class="text-danger">{{
                    total_debit.toLocaleString()
                  }}</span>
                </h5>
              </div>
              <div class="col-md-4">
                <h5>
                  Total Credit:
                  <span class="text-danger">{{
                    total_credit.toLocaleString()
                  }}</span>
                </h5>
              </div>
              <div class="col-md-4">
                <h5>
                  Total Balance:
                  <span class="text-danger">{{
                    total_balance.toLocaleString()
                  }}</span>
                </h5>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="row mt-3" v-if="paginationRows > 0">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="paginationCurrentPage"
                    :total-rows="paginationRows"
                    :per-page="paginationPerPage"
                    :disabled="isLoadingPagination"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
